export const titlePage = (state) => state.titlePage
